module.exports = __webpack_public_path__ + "static/media/chooseDataOptions.c7e80614.wav";